'use client'

import useApp from '@hook/useApp'
import { isWindow } from '@lib/utils'
import { isFunction } from 'lodash-es'
import { useCallback } from 'react'
import ShareDropdown from './ShareDropdown'
import ShareResposive from './ShareResposive'

export { ShareDropdown }

export default function Share(props) {
  const { shareData, onBeforeShare } = props
  const { isMobile } = useApp()

  const handleBeforeShare = useCallback(() => {
    isFunction(onBeforeShare) && onBeforeShare({ data: shareData })
  }, [onBeforeShare, shareData])

  if(isMobile 
      && isWindow 
      && window.navigator?.canShare 
      && window.navigator.canShare(shareData)
  ) {
    return <ShareResposive {...props} onBeforeShare={handleBeforeShare} />
  }
  
  return (
    <ShareDropdown 
      {...props}
      popoverProps={{ onOpen: handleBeforeShare }}
    />
  )
}
